import styled from 'styled-components'

export const NoticeIcon = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 8px;
  color: var(--notice__icon);
`
